var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17337",
    d: "M30.017 3.086h-3.163V1.497a1.5 1.5 0 10-3 0v1.586H17.5V1.497a1.5 1.5 0 10-3 0v1.586H8.145V1.497a1.5 1.5 0 00-3 0v1.586H1.983A1.985 1.985 0 000 5.063v20.953a1.985 1.985 0 001.983 1.981h28.034A1.985 1.985 0 0032 26.016V5.066a1.985 1.985 0 00-1.983-1.98M29 24.997H3V6.086h2.145v.119a1.5 1.5 0 003 0v-.119H14.5v.119a1.5 1.5 0 003 0v-.119h6.354v.119a1.5 1.5 0 003 0v-.119H29z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17338",
    d: "M17.62 9.237h-3.241a1 1 0 00-1 1v3.2a1 1 0 001 1h3.241a1 1 0 001-1v-3.2a1 1 0 00-1-1m-.5 3.7h-2.241v-2.2h2.241z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17339",
    d: "M24.48 9.237h-3.241a1 1 0 00-1 1v3.2a1 1 0 001 1h3.241a1 1 0 001-1v-3.2a1 1 0 00-1-1m-.5 3.7h-2.241v-2.2h2.241z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17340",
    d: "M10.761 9.237H7.519a1 1 0 00-1 1v3.2a1 1 0 001 1h3.242a1 1 0 001-1v-3.2a1 1 0 00-1-1m-.5 3.7H8.019v-2.2h2.242z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17341",
    d: "M17.62 16.645h-3.241a1 1 0 00-1 1v3.2a1 1 0 001 1h3.241a1 1 0 001-1v-3.2a1 1 0 00-1-1m-.5 3.7h-2.241v-2.2h2.241z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17342",
    d: "M24.48 16.645h-3.241a1 1 0 00-1 1v3.2a1 1 0 001 1h3.241a1 1 0 001-1v-3.2a1 1 0 00-1-1m-.5 3.7h-2.241v-2.2h2.241z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17343",
    d: "M10.761 16.645H7.519a1 1 0 00-1 1v3.2a1 1 0 001 1h3.242a1 1 0 001-1v-3.2a1 1 0 00-1-1m-.5 3.7H8.019v-2.2h2.242z",
    fill: "currentColor"
  })));
}
export default SvgCalendar;